import { createReducer } from 'redux-act'
// import u from 'updeep';

const initialState = {
  id: '',
  step: 2,
  activeTab: 0,
  customer: {
    phone: '',
    code: '',
    email: '',
    first_name: '',
    last_name: '',
    guests: 0,
    language: '',
    ui_language: '',
    note: '',
    start: '',
    coupon_code: '',
  },
  gifted: {
    phone: '',
    code: '',
    email: '',
    first_name: '',
    last_name: '',
    guests: 0,
    language: '',
    ui_language: '',
    note: '',
    start: '',
    coupon_code: '',
  },
  coupon: {
    validating: false,
  },
  type: '',
}

export default createReducer({}, initialState)
